import React from 'react'

export const TabBuyer: React.FC = () => {
    return <>TabBuyer</>
}
